import { Component, inject, model, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogTitle, MatDialogContent, MatDialogActions, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MarkdownPipe } from '../../markdown.pipe';
import { MatChipListbox, MatChipsModule } from '@angular/material/chips';
import { CommonModule } from '@angular/common';
import { Verse } from '@models/Verse';
import { VerseTextSelectorComponent } from '../verse-text-selector/verse-text-selector.component';
import { Gloss } from '@models/Gloss';
import { MarkdownAnnotation } from '@models/Annotation';
import { PhraseGlossLocation } from '@models/gloss-locations';
import { SynchronizerService } from '../../synchronizer.service';
import { ProjectConfiguration } from '@models/ProjectConfiguration';
import { ProjectTextStyleDirective } from '../../project-text-style.directive';

export interface PhraseGlossEditorData {
  verse: Verse;
  project: ProjectConfiguration;
}

@Component({
  selector: 'app-phrase-gloss-editor-dialog',
  imports: [CommonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MarkdownPipe,
    MatChipsModule,
    VerseTextSelectorComponent,
    ProjectTextStyleDirective],
  templateUrl: './phrase-gloss-editor-dialog.component.html',
  styleUrl: './phrase-gloss-editor-dialog.component.scss'
})
export class PhraseGlossEditorDialogComponent {
  readonly dialogRef = inject(MatDialogRef<PhraseGlossEditorDialogComponent>);
  readonly data = inject<PhraseGlossEditorData>(MAT_DIALOG_DATA);
  public verse: Verse;
  public project: ProjectConfiguration;
  @ViewChild('chipList') chipList!: MatChipListbox;
  range: PhraseGlossLocation | null = null;

  readonly gloss = model('');
  readonly markdown = model('');

  constructor(public synchronizerService: SynchronizerService) {
    this.verse = this.data.verse;
    this.project = this.data.project;
  }

  setRange(range: PhraseGlossLocation | null) {
    this.range = range;
  }

  onDismiss(): void {
    this.dialogRef.close();
  }

  accept(): void {
    if (this.range !== null && this.synchronizerService.currentUser) {
      const annotation = new MarkdownAnnotation(this.markdown(), -1, 'NA');
      const location = new PhraseGlossLocation(this.range.from, this.range.to);
      const gloss = new Gloss(annotation, -1, location, [this.synchronizerService.currentUser.user_id]);
      this.dialogRef.close(gloss);
    } else {
      this.onDismiss();
    }
  }

}
